import React from 'react';
import { ServiceAreaPill } from '@/components/ui';

/**
 * A relationship shown as plain blue link text (W-M22): "12 foreman areas" opens the child tab
 * filtered to this row. A count of 0 is plain text - there is nothing to open.
 */
export const AreaCountLink: React.FC<{
  count: number;
  label: string;
  onOpen: () => void;
  title?: string;
}> = ({ count, label, onOpen, title }) => {
  if (count === 0) return <span className="tw-text-content-muted">{label}</span>;
  return (
    <button
      type="button"
      onClick={onOpen}
      title={title}
      className="tw-inline-flex tw-min-h-[2rem] tw-items-center tw-border-0 tw-bg-transparent tw-p-0 tw-text-left tw-text-primary tw-underline-offset-2 hover:tw-underline focus-visible:tw-underline"
    >
      {label}
    </button>
  );
};

/** Parent link: the name of the parent area, opening the parent tab filtered to it. */
export const AreaParentLink: React.FC<{ name: string; onOpen: () => void; title?: string }> = ({
  name,
  onOpen,
  title,
}) => (
  <button
    type="button"
    onClick={onOpen}
    title={title}
    className="tw-inline-flex tw-min-h-[2rem] tw-items-center tw-border-0 tw-bg-transparent tw-p-0 tw-text-left tw-text-primary tw-underline-offset-2 hover:tw-underline focus-visible:tw-underline"
  >
    {name}
  </button>
);

/** Service Area parent link, shown as the standard ServiceAreaPill. */
export const ServiceAreaParentLink: React.FC<{
  serviceArea: { id?: number; name?: string | null; code?: string | null } | null | undefined;
  onOpen: (name: string) => void;
}> = ({ serviceArea, onOpen }) => {
  const name = serviceArea?.name?.trim();
  if (!name) return <ServiceAreaPill value={null} />;
  return (
    <button
      type="button"
      onClick={() => onOpen(name)}
      title={`Show ${name} on the Service Areas tab`}
      className="tw-inline-flex tw-min-h-[2rem] tw-items-center tw-border-0 tw-bg-transparent tw-p-0"
    >
      <ServiceAreaPill value={serviceArea} className="tw-cursor-pointer" />
    </button>
  );
};
